"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSHUMANS_POLICY_4 = exports.TRANSHUMANS_POLICY_3 = exports.TRANSHUMANS_POLICY_2 = exports.TRANSHUMANS_DEFAULT_POLICY = exports.TRANSHUMANS_BONUS_2 = exports.TRANSHUMANS_BONUS_1 = exports.Transhumans = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Resources_1 = require("../../Resources");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const PlayProjectCard_1 = require("../../deferredActions/PlayProjectCard");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const MarsCoalition_1 = require("../../cards/community/corporations/MarsCoalition");
const TranshumansPolicy2Action_1 = require("../../cards/turmoil/standardActions/TranshumansPolicy2Action");
const TranshumansPolicy3Action_1 = require("../../cards/turmoil/standardActions/TranshumansPolicy3Action");
class Transhumans extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.TRANSHUMANS;
        this.description = 'Seeks to foster growth by pushing the boundaries of human limits.';
        this.bonuses = [exports.TRANSHUMANS_BONUS_1, exports.TRANSHUMANS_BONUS_2];
        this.policies = [exports.TRANSHUMANS_DEFAULT_POLICY, exports.TRANSHUMANS_POLICY_2, exports.TRANSHUMANS_POLICY_3, exports.TRANSHUMANS_POLICY_4];
    }
}
exports.Transhumans = Transhumans;
class TranshumansBonus01 {
    constructor() {
        this.id = 'tb01';
        this.isDefault = true;
        this.description = 'Gain 1 M€ for each card with requirements you have played';
    }
    getScore(player) {
        return player.playedCards.filter((card) => card.requirements !== undefined).length;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class TranshumansBonus02 {
    constructor() {
        this.id = 'tb02';
        this.description = 'Gain 2 M€ for each card with no tags you have played';
        this.isDefault = false;
    }
    getScore(player) {
        return player.getNoTagsCount() * 2;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class TranshumansPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_DEFAULT_POLICY;
        this.description = 'Gain 1 wild tag for this generation';
    }
}
class TranshumansPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_2;
        this.description = 'Spend 10 M€ to gain 1 influence';
        this.isDefault = false;
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canAfford(10) && player.canUseSingleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const game = player.game;
        const turmoil = player.game.turmoil;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new TranshumansPolicy2Action_1.TranshumansPolicy2Action()));
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 10, { title: 'Select how to pay for action' }));
        turmoil.addInfluenceBonus(player);
        MarsCoalition_1.MarsCoalition.handleSingleUsePolicyLogic(player, isDominantPartyAction);
        return undefined;
    }
}
class TranshumansPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_3;
        this.description = 'Spend 10 M€ to play a card from hand, ignoring global requirements';
        this.isDefault = false;
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canAfford(10) && player.canUseSingleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new TranshumansPolicy3Action_1.TranshumansPolicy3Action()));
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 10, { title: 'Select how to pay for action' }));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            MarsCoalition_1.MarsCoalition.handleSingleUsePolicyLogic(player, isDominantPartyAction);
            return undefined;
        }));
        game.defer(new PlayProjectCard_1.PlayProjectCard(player));
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            if (isDominantPartyAction) {
                player.dominantPartyActionUsedCount = 0;
            }
            else {
                player.turmoilPolicyActionUsed = false;
            }
            return undefined;
        }));
        return undefined;
    }
}
class TranshumansPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_4;
        this.description = 'When you trade, you may first increase that Colony Tile track 1 step';
        this.isDefault = false;
    }
    apply(game) {
        game.getPlayers().forEach((player) => {
            player.hasTranshumansColonyTradeOffset = true;
        });
    }
}
exports.TRANSHUMANS_BONUS_1 = new TranshumansBonus01();
exports.TRANSHUMANS_BONUS_2 = new TranshumansBonus02();
exports.TRANSHUMANS_DEFAULT_POLICY = new TranshumansPolicy01();
exports.TRANSHUMANS_POLICY_2 = new TranshumansPolicy02();
exports.TRANSHUMANS_POLICY_3 = new TranshumansPolicy03();
exports.TRANSHUMANS_POLICY_4 = new TranshumansPolicy04();
//# sourceMappingURL=Transhumans.js.map